<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ProductService from '@/services/product';

export default {
  page: {
    title: "Categorias",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Categorias",
      categories: [],
      fields: [
        // { key: '_id', label: 'ID' },
        { key: 'full_description', label: 'Descrição' },
        { key: 'products_count', label: 'Qtde. Produtos' },
        { key: 'actions', label: 'Ações' },
      ],
      categoryToRemove: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    };
  },
  methods: {
    load(page = 1) {
      let loader = this.$loading.show();

      ProductService.getCategories(page).then(res => {
        this.categories = res.data.list;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;

        loader.hide();
      }).catch(err => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    removeCategory() {
      this.$bvModal.hide('modal-remove');    
      
      ProductService.removeCategory(this.categoryToRemove._id).then(() => {
        this.load();
        this.$toast.open('Categoria removida');
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao excluir ca categoria');
      })
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row mb-2">
              <div class="col-12">
                <div class="text-right">
                  <router-link to="/categories/edit">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2">
                      <i class="mdi mdi-plus mr-1"></i> Nova Categoria
                    </button>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="categories"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <!-- <template v-slot:cell(description)="row">
                  <span
                    class="badge badge-pill badge-soft-primary font-size-12 mr-2"
                    :class=" {
                      'ml-3': row.item.level === 2,
                      'ml-5': row.item.level === 3,
                    }"
                  >Nível {{row.item.level}}</span>
                  {{row.item.description}}
                </template> -->

                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>

                    <router-link class="dropdown-item" :to="'/categories/edit/' + row.item._id">
                      <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar
                    </router-link>
                    
                    <b-dropdown-item v-b-modal.modal-remove @click="categoryToRemove = row.item">
                      <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i> Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <!-- <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div> -->
      </div>
    </div>

     <b-modal
      id="modal-remove"
      title="Excluir Categoria?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão da categoria? Os produtos que possuem essa atribuição serão afetados.</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeCategory">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  // .level-2 {
  //   margin-leg
  // }
</style>